import React from "react";
import styles from "./widgetInputLabel.css";

interface Props {
  text: string;
}
export const WidgetInputLabel = ({ text }: Props) => {
  return <span className={styles.label}>{text}</span>;
};
